import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const GYG_CORE_SRC = 'https://widget.getyourguide.com/v2/core.js';

let gygCoreLoadPromise = null;

/**
 * Loads GetYourGuide widget core.js once; partner id is read from [data-gyg-partner-id] on the widget div.
 */
function ensureGygCoreScript() {
  if (typeof document === 'undefined') {
    return Promise.resolve();
  }
  if (document.querySelector('script[src*="widget.getyourguide.com/v2/core"]')) {
    return Promise.resolve();
  }
  if (!gygCoreLoadPromise) {
    gygCoreLoadPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.async = true;
      s.defer = true;
      s.src = GYG_CORE_SRC;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('GetYourGuide widget script failed to load'));
      document.head.appendChild(s);
    });
  }
  return gygCoreLoadPromise;
}

/**
 * Embeds the official GetYourGuide activity widget (script + container per Widgets 101).
 */
function GetYourGuideWidget({
  partnerId,
  query,
  localeCode,
  dateFrom,
  dateTo,
  contextText,
  moreHref,
  onMoreClick,
}) {
  const { t } = useTranslation();

  useEffect(() => {
    ensureGygCoreScript().catch(() => {});
  }, []);

  return (
    <div
      className="travel-item-card__gyg-widget"
      data-gyg-widget="activities"
      data-gyg-partner-id={partnerId}
      data-gyg-q={query}
      data-gyg-number-of-items="3"
      data-gyg-locale-code={localeCode}
      data-gyg-date-from={dateFrom}
      data-gyg-date-to={dateTo}
    >
      <span className="travel-item-card__gyg-context">{contextText}</span>
      {moreHref && (
        <a
          className="travel-item-card__gyg-more"
          href={moreHref}
          target="_blank"
          rel="noreferrer sponsored"
          onClick={onMoreClick}
        >
          {t('travelCard.gygSeeMore')}
        </a>
      )}
    </div>
  );
}

export default GetYourGuideWidget;
